"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteSelector = void 0;
const react_1 = __importStar(require("react"));
const useAutocomplete_1 = require("@mui/material/useAutocomplete");
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = __importDefault(require("debounce"));
const autocomplete_selector_styles_1 = require("./autocomplete-selector.styles");
const list_box_component_1 = require("./list-box.component");
const utils_1 = require("../../utils");
const localization_1 = require("../../../localization");
const LOAD_MORE_TRIGGER_GAP = 30;
const AutocompleteSelector = (_a) => {
    var { options, onChange, selected, placeholder, label, hasNextPage, groupBy, className, error, errorMessage, isLoading, moreItemsLoading, noOptionsText, allowCreation, isDisabled, preserveInputOnSelect, onBlur, onLoadMore, onSearch, getOptionDisabled } = _a, rest = __rest(_a, ["options", "onChange", "selected", "placeholder", "label", "hasNextPage", "groupBy", "className", "error", "errorMessage", "isLoading", "moreItemsLoading", "noOptionsText", "allowCreation", "isDisabled", "preserveInputOnSelect", "onBlur", "onLoadMore", "onSearch", "getOptionDisabled"]);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [inputValue, setInputValue] = (0, react_1.useState)();
    const filter = (0, react_1.useMemo)(() => {
        if (onLoadMore) {
            return undefined;
        }
        return (0, useAutocomplete_1.createFilterOptions)();
    }, [onLoadMore]);
    const onSearchChanged = (0, react_1.useMemo)(() => (0, debounce_1.default)((search) => onSearch(search), 250), [onSearch]);
    (0, react_1.useEffect)(() => () => {
        onSearchChanged.clear();
    }, [onSearchChanged]);
    const handleInputChange = (_e, newValue, reason) => {
        if (reason === 'reset' || (preserveInputOnSelect && reason !== 'input' && reason !== 'clear')) {
            return;
        }
        setInputValue(newValue);
        if (newValue !== inputValue && onSearch) {
            void onSearchChanged(newValue);
        }
    };
    const handleChange = (_e, option, _reason, _details) => {
        const selectedOption = Array.isArray(option) ? option[0] : option;
        if (selectedOption === null || selectedOption === undefined) {
            return;
        }
        if (typeof selectedOption === 'string') {
            if (!preserveInputOnSelect) {
                setInputValue(String(selectedOption));
            }
            onChange(selectedOption);
            return;
        }
        const normalizedOption = selectedOption;
        const { label, value, isSystemLabel } = normalizedOption !== null && normalizedOption !== void 0 ? normalizedOption : {};
        if (!preserveInputOnSelect) {
            setInputValue(isSystemLabel ? value : label);
        }
        if (value !== undefined) {
            onChange(value);
        }
    };
    const onScroll = (0, react_1.useCallback)((event) => {
        if (moreItemsLoading) {
            return;
        }
        const listboxNode = event.currentTarget;
        if (Math.floor(listboxNode.scrollTop + listboxNode.clientHeight) >= (listboxNode.scrollHeight - LOAD_MORE_TRIGGER_GAP)) {
            void onLoadMore();
        }
    }, [moreItemsLoading, onLoadMore]);
    const renderFilterOptions = (options, params) => {
        const newOptions = onLoadMore ? [...options] : filter(options, params);
        if (!allowCreation) {
            return newOptions;
        }
        const { inputValue } = params;
        const isExisting = options.some((option) => (0, utils_1.areEqualCaseInsensitive)(inputValue, option.label));
        if (inputValue && !isExisting) {
            newOptions.push({
                value: inputValue,
                isSystemLabel: true,
                label: `${String(t({ key: 'CREATE_NEW' }))} "${inputValue}"`,
            });
        }
        return newOptions;
    };
    const selectedOption = options.find((option) => option.value === selected);
    const derivedInputValue = inputValue !== null && inputValue !== void 0 ? inputValue : ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '');
    const listBoxProps = onLoadMore
        ? {
            onScroll: hasNextPage ? onScroll : undefined,
            moreItemsLoading,
            className: (0, classnames_1.default)({ 'list--loading': isLoading }),
        }
        : undefined;
    return (react_1.default.createElement(autocomplete_selector_styles_1.StyledAutocompleteSelector, Object.assign({ disabled: isDisabled, PaperComponent: autocomplete_selector_styles_1.StyledPaper, label: label, InputProps: placeholder ? { placeholder } : undefined, ListboxComponent: list_box_component_1.ListBox, ListboxProps: listBoxProps, onChange: handleChange, onInputChange: handleInputChange, inputValue: derivedInputValue, options: options, value: selectedOption !== null && selectedOption !== void 0 ? selectedOption : null, variant: 'outlined', selectOnFocus: true, groupBy: groupBy, className: className, error: error, errorMsg: errorMessage, onBlur: onBlur, loading: isLoading, filterOptions: renderFilterOptions, noOptionsText: noOptionsText, getOptionDisabled: getOptionDisabled }, rest)));
};
exports.AutocompleteSelector = AutocompleteSelector;
exports.default = exports.AutocompleteSelector;
